import { isUtilityInteractionStateProp, isUtilityPropName } from '@smoothie-framework/ui-styles/styling';
const SEMANTIC_DATA_AS_COMPONENT_TYPES = new Set([
    'Text',
    'Box',
    'Flex',
    'Stack',
    'StackRow',
    'StackCol',
    'Grid',
    'GridItem',
    'Spacer',
    'Divider',
    'ScrollArea',
    'Breadcrumb',
    'BreadcrumbList',
    'BreadcrumbItem',
    'BreadcrumbLink',
    'BreadcrumbCurrentLink',
    'BreadcrumbSeparator',
    'BreadcrumbEllipsis',
]);
export const STATIC_EVENT_MAPPINGS = [
    ['onClick', 'click'],
    ['onMouseEnter', 'mouseenter'],
    ['onMouseLeave', 'mouseleave'],
    ['onMouseDown', 'mousedown'],
    ['onContextMenu', 'contextmenu'],
    ['onFocus', 'focus'],
    ['onBlur', 'blur'],
    ['onKeyDown', 'keydown'],
    ['onDragStart', 'dragstart'],
    ['onDragEnd', 'dragend'],
    ['onDragEnter', 'dragenter'],
    ['onDragOver', 'dragover'],
    ['onDragLeave', 'dragleave'],
    ['onDrop', 'drop'],
];
export function isClassProp(propName) {
    return propName === 'className';
}
export function isManagedClassProp(propName) {
    return isUtilityPropName(propName) || isUtilityInteractionStateProp(propName);
}
export function isRefProp(propName) {
    return propName === 'ref';
}
export function isStyleProp(propName) {
    return propName === 'style';
}
export function isEventProp(propName) {
    switch (propName) {
        case 'onClick':
        case 'onMouseEnter':
        case 'onMouseLeave':
        case 'onMouseDown':
        case 'onContextMenu':
        case 'onFocus':
        case 'onBlur':
        case 'onKeyDown':
        case 'onDragStart':
        case 'onDragEnd':
        case 'onDragEnter':
        case 'onDragOver':
        case 'onDragLeave':
        case 'onDrop':
        case 'onInput':
        case 'onChange':
            return true;
        default:
            return false;
    }
}
export function isSemanticTagProp(type, propName) {
    return (type !== undefined && propName === 'data-as' && SEMANTIC_DATA_AS_COMPONENT_TYPES.has(type))
        || (type === 'Heading' && propName === 'data-level');
}
export function getStaticEventName(propName) {
    for (const [name, eventName] of STATIC_EVENT_MAPPINGS) {
        if (name === propName) {
            return eventName;
        }
    }
    return undefined;
}
//# sourceMappingURL=prop-flags.js.map